#@import ResponsiveCSS
#@import JqueryBullseye
#@import LastMinuteModal
#@import Occasions.Templates

require './vendor_modules/jquery.bullseye-1.0.js'
require './vendor_modules/last-minute-modal.js'
require '../../modules/doubleclick/frontend/dfp_ads.coffee'
hoganPartials = require '../../modules/merchandising_occasions/frontend/template-include-partials.coffee'
urlUtils = require '../../modules/merchandising_occasions/frontend/url-utils.coffee'
paginationCard = require '../../modules/merchandising_occasions/frontend/pagination-card.coffee'
FacetLoader = require '../../modules/merchandising_occasions/frontend/facet-loader.coffee'
soldOutTemplate = require '../../modules/merchandising_occasions/shared/sold-out-template.html.mustache'
facetTemplate = require '../../modules/merchandising_occasions/shared/facet-template.html.mustache'
priceRangeTemplate = require '../../modules/merchandising_occasions/shared/price-range.html.mustache'
loadMoreTemplate = require '../../modules/merchandising_occasions/shared/load-more-deals.html.mustache'
cardUI = require 'grpn-card-ui/lib/frontend'

getCardUi = ()->
  if typeof CardUI != "object"
    return {init: ()->}
  return CardUI

# On ready, add JS class
(($) ->
  lastRequest = ""
  paginatedDealIds = {}
  pageConfig = {}
  paginationFacets = {}
  if $?
    $(document).ready ->
      $(".primary-nav .Occasion").addClass "active"
      BOOMR["app_name"] = "{{appName}}"
      $('body').removeClass 'no-js'
      positionInAppMessages()
      pageConfig = Groupon.Utils.getConfigFromDom()
      $('#load-more-deals').on('click', loadMoreDealsEvent)
      if $(".main.row.module.giftable").is('*') # WARNING: unlike most events, enterviewport will fire synchronously - any error will prevent additional listeners from being attached and hault this init function
        $("#category-deals:not(.dont-load) [data-deal-type]").bind('enterviewport', loadThemeDeals).bullseye()
      if window.location.href.indexOf('show-gift-modal=true') > 5
        showLastMinuteModal()
      lhnFacets = new FacetLoader(pageConfig.facets, pageConfig.subnavFacets, pageConfig.subnavFacetsMinimumDeals)
      showSubnavFacets(lhnFacets.loadedFacets)
      paginationFacets = new FacetLoader(pageConfig.facets, pageConfig.paginationFacets, pageConfig.paginationFacetsMinimumDeals)
      showPriceFilters()
      updatePaginationCardHref($('#load-more-deals'))
      setTimeout initAtEnd, 0

  initAtEnd = () ->
    initPaginatedDealIds()
    initRoutes()
    getCardUi().init()
    Groupon.Performance.pageReady() # should always call this last

  initPaginatedDealIds = () ->
    initialCards = $('a.deal-url')
    initialCards = $('figure.card-ui') unless initialCards.length
    _.each initialCards, (dealCardLink) ->
      $dealCardLink = $(dealCardLink)
      dealId = dealCardLink.getAttribute('data-pagination-id')
      if dealId
        paginatedDealIds[dealId] = true
      else
        paginatedDealIds[($dealCardLink.closest('a').attr('href') || '').match(/[-\w]+$/)] = true
      return if $dealCardLink.hasClass('load-more-deals') or $dealCardLink.find('.load-more-deals').length # for cui cards we do not wish to attach event to pagination cards
      $dealCardLink.closest('li,.featured-deal,figure.cui-c-deal-featured,figure.cui-c-deal-featured-fallback').on 'click', initiallyLoadedCardClicked

  updatePaginationCardHref = (loadMoreBtn) ->
    newHref = loadMoreBtn.attr("data-href-template")
    if !newHref
      newHref = urlTemplateBuilder("")
    newHref = paginationTemplateUrlSetOffset(newHref, loadMoreBtn.attr("data-next-offset"))
    loadMoreBtn.attr("href", newHref)

  paginationTemplateUrlSetOffset = (href, offset) ->
    return href.replace('{OFFSET}', offset)

  popStateCallback = () ->
    #Do nothing

  popState = (ev) ->
    applyState(ev.state, popStateCallback,true)

  applyState = (state, callback, hasHistoryChanged) ->
    hasCats = hasHistoryChanged || false
    if state and state.stateQuery
      $('.nav-facets input:checked').prop('checked', false)
      $('#price-filter input:checked').prop('checked', false)
      stateQuery = state.stateQuery
      for catType of stateQuery
        typeFirst8 = catType.substr(0,8)
        if typeFirst8 in ['category', 'subcateg'] || catType == 'deal_type' # please note ['category', 'subcateg'] is not an Array - check the compiled JS and avoid using [].indexOf
          hasCats = true
          categories = stateQuery[catType].split(',')
          for category in categories
            $("#facet_#{catType}_"+category).prop('checked', true)
        if catType == 'priceFilters'
          hasCats = true # bad variable name
          priceFilters = stateQuery[catType].split(',')
          for priceFilter in priceFilters
            priceFilter = priceFilter.replace('..','_').replace('*','infinity')
            $('#price-filter #range_'+priceFilter).prop('checked', true)
    if hasCats
      facetSelectionChangeDebounced(callback)
    else
      callback?()

  initRoutes = () ->
    fragmentParams = urlUtils.parseLocationHash()
    if history.replaceState
      # we should parse the current state and store it here
      query = urlUtils.parseQueryString(window.location.search)
      qs = urlUtils.buildQueryString(query)
      history.replaceState({stateQuery:query},document.title,window.location.pathname + qs + urlUtils.currentFragment())
      applyState {stateQuery:query}, () =>
        if fragmentParams.offset
          if fragmentParams.setId and pageConfig.showSubnavFacets
            showLoadMoreChoicesBtns lastUl()
            $loadMoreBtn = $('.load-more-choices#load-more-deals-from-'+fragmentParams.setId)
            if $loadMoreBtn.length
              setupInitialOffset fragmentParams, $loadMoreBtn
          else
            setupInitialOffset fragmentParams
    window.addEventListener('popstate', popState)

  showPriceFilters = ()->
    if pageConfig.showPriceFilter and pageConfig.priceFilters and pageConfig.priceFilters[I18n.country]
      currencyOpts = {currencyCode: pageConfig.priceFilters[I18n.country].code, short:true}
      $priceFilter = $(document.createDocumentFragment())
      $priceFilter.append($("<h4>"+I18n.t('js.modules.merchandising_occasions.price_ranges')+"</h4>"))
      for range in pageConfig.priceFilters[I18n.country].ranges
        name = I18n.toCurrency(range.from, currencyOpts)
        if range.to != "*"
          name += " " + I18n.t 'js.modules.merchandising_occasions.range_separator'
          name += " " + I18n.toCurrency(range.to, currencyOpts)
        else
          name += I18n.t 'js.modules.merchandising_occasions.range_infinite'
        range.name = name
        range.safeTo = "#{range.to}".replace("*",'infinity')
        $rangeCheckbox = $(priceRangeTemplate.render range)
        $rangeCheckbox.find('input').on('change', facetSelectionChangeDebounced)
        $priceFilter.append($rangeCheckbox)
      $('#price-filter').append($priceFilter)

  showSubnavFacets = (subnavFacets) ->
    if subnavFacets.length and pageConfig.showSubnavFacets
      $liHolder = $('<li class="indent nav-facets"></li>') # consider use of a template
      for facet in subnavFacets
        $facetTemplate = $(facetTemplate.render facet)
        $facetTemplate.find('input').on('change', facetSelectionChangeDebounced)
        $liHolder.append($facetTemplate)
      $liHolder.insertAfter(".gift-sidebar li.selected")

  lastUl = () ->
    $('#result-list ul:last')

  loadingDeals = () ->
    $('#result-list').css('opacity', 0.5)
    $('#result-list #loading').show()

  notLoadingDeals = () ->
    $('#result-list').css('opacity', 1.0)
    $('#result-list #loading').hide()

  getHeroDealNode = () ->
    return $('#result-list #heroContainer')

  getCurrentDealNodes = () ->
    return $('#result-list li')

  getDivisionLatLng = () ->
    return paginationCard.getDivisionLatLng(pageConfig)

  getSelectableCategories = () ->
    getCategoriesForCheckboxes($('.nav-facets input'))

  getSelectedCategories = () ->
    getCategoriesForCheckboxes($('.nav-facets input:checked'))

  getCategoriesForCheckboxes = (catCheckboxes) ->
    foundCats = []
    queryCats = []
    mappedCats = {}
    _.each catCheckboxes, (chk) ->
      $chk = $(chk)
      catType = $chk.data('category-type')
      name = $chk.data('category-name')
      cat =  $chk.data('category')
      query = catType + ':' + cat
      queryCats.push(query)
      foundCats.push
        type: catType
        id: cat
        name: name
        query: query
      if not mappedCats[catType]
        mappedCats[catType] = cat
      else mappedCats[catType] += ",#{cat}"
    catQuery = queryCats.join(" OR ")
    {foundCats, mappedCats, catQuery}

  getSelectedPriceRanges = () ->
    checkedRanges = $('#price-filter input:checked')
    foundRanges = []
    mappedRanges = {}
    priceFilter = ""
    _.each checkedRanges, (chk) ->
      $chk = $(chk)
      foundRanges.push($chk.data('range'))
    if foundRanges.length
      priceFilter = " AND price:["+foundRanges.join('];[')+"]"
      mappedRanges.priceFilters = foundRanges.join(',')
    {priceRanges: foundRanges, mappedRanges, priceFilter}

  facetSelectionChanged = (callbackFn) ->
    # we need to bail early here if RAPI is disabled, since it may be disabled at any time
    return unless pageConfig.showSubnavFacets or pageConfig.showPriceFilter
    {foundCats, mappedCats, catQuery} = getSelectedCategories()
    {priceRanges, mappedRanges, priceFilter} = getSelectedPriceRanges()
    stateMap = _.extend({}, mappedRanges, mappedCats)
    urlPath = urlUtils.buildQueryString stateMap

    filterQuery = "deal_type:#{pageConfig.occasion.dealType}"
    if foundCats.length
      filterQuery += " AND (#{catQuery})"
    latLng = getDivisionLatLng()

    if priceRanges.length
      filterQuery += priceFilter

    query_filter_string = urlUtils.apiQueryBuilder _.extend({
      filterQuery: filterQuery
      latLng: latLng
      includeHtml: pageConfig.newRender
    }, pageConfig.occasion)

    offset = 0
    limit = pageConfig.pageLimit

    heroDeal = getHeroDealNode()
    nodesToClearOnSuccess = getCurrentDealNodes()

    $loadMoreBtnA = createLoadMoreButton lastUl(), false, false,
      'data-filter-query': filterQuery
      'data-division-loc': latLng
      'data-href-template': urlTemplateBuilder(urlPath)
    $loadMoreBtn = $loadMoreBtnA.closest('li')

    oldPaginatedIds = paginatedDealIds
    paginatedDealIds = {} # if the load is successful, we clear the prior results, so do not dedupe against them, we'll set this back later if the results fail to load
    loadingDeals()

    loadDeals $loadMoreBtnA, $loadMoreBtn, query_filter_string, offset, limit, false, nodesToClearOnSuccess, heroDeal, (success, dupe) ->
      notLoadingDeals()
      if success
        newState = {stateQuery:stateMap}
        if history.pushState and not _.isEqual(history.state, newState) # we should not push state if our current state is already represented (initial page load time)
          history.pushState(newState,document.title,window.location.pathname + urlPath) # + urlUtils.currentFragment() # if we do not drop the fragment, we should make sure to at least set the offset to 0
        OptimizeSuite.treatAsNewPage(window.location.pathname + urlPath)
        callbackFn?()
      else
        paginatedDealIds = oldPaginatedIds unless dupe
        $loadMoreBtn.remove()

  # the debounced version of facetSelectionChanged will only be called once per given interval, allows us to react only once to many changes
  facetSelectionChangeDebounced = _.debounce(facetSelectionChanged, 100)

  setupInitialOffset = (fragmentParams, loadMoreBtn) ->
    queryOffset = fragmentParams.offset-0
    setId = fragmentParams.setId or ''
    scrollId = queryOffset
    dealHref = unescape(fragmentParams.deal)
    if not loadMoreBtn or not loadMoreBtn.length
      loadMoreBtn = $('#load-more-deals') # in rare conditions we may not find this on the page, in which case offset is probably not needed
    return unless loadMoreBtn.length
    offset = loadMoreBtn.attr("data-next-offset") - 0
    if offset < queryOffset
      cardToClone = loadMoreBtn.closest('li')
      newCard = $(document.createElement('li'))
      newCard.insertBefore(cardToClone)
      newCard.html(cardToClone.html()) # we insert the node before html cloning to support <figure> tags in IE7,8
      newCardLink = newCard.find('a')
      newCardLink.attr 'id', 'load-previous-deals'
      newCardLink.attr 'data-max-offset', queryOffset
      newCardLink.attr 'data-bhc', newCardLink.attr('data-bhc').replace(/^pagination/, 'pagination_hidden')
      remaining = queryOffset - offset
      newCard.find('.deal-title').text(I18n.t 'js.modules.merchandising_occasions.show_hidden')
      newCard.find('.merchant-name').text(I18n.pluralize remaining, 'js.modules.merchandising_occasions.hidden_deals')
      label = newCardLink.attr 'data-set-label'
      if label
        textNodeBefore newCard.find('.deal-title'), label
      newCardLink.on 'click', loadMoreDealsEvent
      loadMoreBtn.attr "data-next-offset", queryOffset
      updatePaginationCardHref(loadMoreBtn)
    loadMoreDeals loadMoreBtn, (success)->
      scrollToIt = () ->
        exact = $("a[href='#{dealHref}']")[0]
        rough = $("li[data-set='#{setId}'][data-offset='#{scrollId}']")[0]
        rough2 = $("li[data-set='#{setId}']")[0]
        rough3 = $("[data-offset='#{scrollId}']")[0]
        exact = exact or rough or rough2 or rough3
        if exact
          if typeof exact.scrollIntoViewIfNeeded == 'function'
            exact.scrollIntoViewIfNeeded()
          else
            $('html, body').scrollTop($(exact).offset().top)
      setTimeout scrollToIt, 250

  initiallyLoadedCardClicked = (ev) ->
    $target = $(ev.currentTarget)
    $a = $target.find('a')
    href = escape($a.attr 'href')
    urlUtils.setFragment "deal=#{href}"

  clonedCardClicked = (ev) ->
    $target = $(ev.currentTarget)
    $a = $target.find('a')
    offset = $target.attr 'data-offset'
    href = escape($a.attr 'href')
    extraFilter = getExtraFilter($a)
    urlUtils.setFragment "offset=#{offset}&deal=#{href}#{extraFilter}"

  loadMoreDealsEvent = (ev)->
    ev.preventDefault()
    loadMoreBtn = $(this)
    loadMoreDeals(loadMoreBtn)
    offset = loadMoreBtn.attr("data-next-offset") - 0
    extraFilter = getExtraFilter(loadMoreBtn)
    if offset or extraFilter
      urlUtils.setFragment "offset=#{offset}#{extraFilter}" # if we are using push state, we neeed to be careful here, to see if anything actually changed before trying to load anything

  getExtraFilter = ($a)->
    extraFilter = ''
    setId = $a.attr('data-set-id')
    if setId
      extraFilter = "&setId=#{setId}"
    return extraFilter

  loadMoreDeals = (loadMoreBtn, callbackFn) ->
    query_filter_string = urlUtils.apiQueryBuilder paginationCard.loadButtonAttributes(loadMoreBtn, pageConfig)
    offset = loadMoreBtn.attr("data-next-offset") - 0
    limit = (loadMoreBtn.attr("data-limit") - 0) or 99
    maxOffset = loadMoreBtn.attr("data-max-offset") - 0
    # return unless offset and offset > 0
    loadDeals loadMoreBtn, loadMoreBtn.parents('li'), query_filter_string, offset, limit, maxOffset, [], false, callbackFn

  heroReadyToShow = (hero, paginatedKey) ->
    GIG.Utils.truncateElements(hero)
    hero.show()
    paginatedDealIds[paginatedKey] = true

  loadDeals = (loadMoreBtn, cardToClone, query_filter_string, offset, limit, maxOffset, toRemoveOnSuccess, optionalHero, callbackFn) ->
    loadMoreParentLi = loadMoreBtn.closest('li')
    loadMoreBtn.removeClass('error').addClass('loading')
    setId = loadMoreBtn.attr('data-set-id') or ''
    url = "/occasion/deals-json?#{query_filter_string}&offset=#{offset}&limit=#{limit}"
    lastRequest = url
    $.ajax
      url: url
      dataType: "json"
      timeout: 8000
      success: (json) ->
        loadMoreBtn.removeClass('loading')
        if lastRequest != url
          # another subsequent request is newer, skip this
          callbackFn?(false, true)
          return
        cards = cardsForResp json
        if cards
          r = 0
          rl = cards.length
          total = json.pagination.count
          newOffset = json.pagination.nextOffset
          if toRemoveOnSuccess.length
            toRemoveOnSuccess.remove()
          if optionalHero and optionalHero.length
            if rl > 0
              {dealData, cardHtml, paginatedKey} = metaForDeal cards[r]
              heroCard = optionalHero.find('figure.featured-deal')
              if cardHtml
                optionalHero.empty().append($(cardHtml))
                heroReadyToShow(optionalHero, paginatedKey)
                getCardUi().init(optionalHero.find('.card-ui').not('.is-initialized'))
                r++
              else if heroCard.length
                dealDataIntoResultNode dealData, heroCard
                heroReadyToShow(optionalHero, paginatedKey)
                r++
              else
                optionalHero.hide()
            else
              optionalHero.hide()
          if newOffset == offset # we didn't acutally get any new deals back from the request... API lied about the total
            outOfDeals(loadMoreParentLi)
            callbackFn?(true)
            return
          loadMoreBtn.attr("data-next-offset", newOffset)
          updatePaginationCardHref(loadMoreBtn)
          while r < rl
            {dealData, cardHtml, paginatedKey} = metaForDeal cards[r]
            if not paginatedDealIds[paginatedKey]
              if cardHtml
                newCard = $(cardHtml)
                newCard.find('a').attr('data-limit', 1) # supports same integration test in if cardHtml branch
                newCard.find('a').attr('data-set-id', setId)
                newCard.insertBefore(loadMoreParentLi)
              else
                newCard = $(document.createElement('li'))
                newCard.insertBefore(loadMoreParentLi)
                newCard.html(cardToClone.html()) # we insert the node before html cloning to support <figure> tags in IE7,8
                dealDataIntoResultNode dealData, newCard
              newCard.on 'click', clonedCardClicked
              newCard.attr 'data-offset', offset
              newCard.attr 'data-set', setId if setId
              GIG.Utils.truncateElements(newCard)
              paginatedDealIds[paginatedKey] = true
            r++
          Groupon.Utils.lazyLoadImages()
          getCardUi().init($('.card-ui').not('.is-initialized'))
          if offset + rl >= total or newOffset >= total or (maxOffset and newOffset >= maxOffset)
            outOfDeals(loadMoreParentLi)
          else
            if maxOffset
              remaining = maxOffset - newOffset
              loadMoreBtn.find('.merchant-name').text(I18n.pluralize(remaining, 'js.modules.merchandising_occasions.hidden_deals'))
            else
              remaining = total - newOffset
              loadMoreBtn.find('.merchant-name').text(I18n.pluralize(remaining, 'js.modules.merchandising_occasions.remaining_deals'))
          callbackFn?(true)
      error: ->
        loadMoreBtn.removeClass('loading').addClass('error')
        callbackFn?(false)

  outOfDeals = (loadMoreParentLi) ->
    ulContainer = loadMoreParentLi.closest('ul')
    loadMoreChoices = $('.load-more-choices')
    loadMoreParentLi.remove()
    if loadMoreChoices.length == 0 # we may have just removed the last .load-more-choices, but we still counted it first, so we will not create them more than once
      showLoadMoreChoicesBtns(ulContainer)

  urlTemplateBuilder = (urlPath, setId) ->
    url = pageConfig.occasion.permalink + urlPath + '#offset={OFFSET}'
    if setId
      url += "&setId=" + setId
    return url

  showLoadMoreChoicesBtns = (ulContainer) ->
    return unless pageConfig.showMoreChoices
    loadMoreChoices = $('.load-more-choices')
    return unless loadMoreChoices.length == 0
    {foundCats, mappedCats} = getSelectedCategories()
    {priceRanges, mappedRanges, priceFilter} = getSelectedPriceRanges()
    stateMap = _.extend({}, mappedRanges, mappedCats)
    urlPath = urlUtils.buildQueryString stateMap
    if foundCats.length
      setId = 'dealtype'
      hrefTemplate = urlTemplateBuilder(urlPath, 'dealtype')
      createLoadMoreButton ulContainer, pageConfig.occasion.displayName, 'load-more-choices',
        id: "load-more-deals-from-#{setId}"
        'data-set-id': setId
        'data-nohero': true
        'data-href-template': hrefTemplate
        'href': paginationTemplateUrlSetOffset(hrefTemplate, '0')
      latLng = getDivisionLatLng()
    else
      {foundCats} = paginationFacets.getCategories()
      if not foundCats.length
        {foundCats} = getSelectableCategories()
    if foundCats.length
      for cat in foundCats
        catQuery = cat.query
        if priceRanges.length
          catQuery += priceFilter
        hrefTemplate = urlTemplateBuilder(urlPath, cat.id)
        createLoadMoreButton ulContainer, cat.name, 'load-more-choices',
          'id': "load-more-deals-from-#{cat.id}"
          'data-set-id': cat.id
          'data-nohero': true
          'data-filter-query': catQuery
          'data-division-loc': latLng
          'data-href-template': hrefTemplate
          'href': paginationTemplateUrlSetOffset(hrefTemplate, '0')
          # we may want to set the href to support open pagination card in new tab

  textNode = (text) ->
    document.createTextNode(text)

  textNodeBefore = ($elm, text) ->
    $elm.prepend($('<br/>'))
    $elm.prepend(textNode(text))

  createLoadMoreButton = ( container, title, classes, extraAttr ) ->
    paginationBhc = "dealType-" + pageConfig.occasion.dealType
    if extraAttr['data-filter-query']
      paginationBhc = "filter-" + escape(extraAttr['data-filter-query'])
    else if pageConfig.occasion.isCategoryFallback and pageConfig.occasion.categoryFallback
      paginationBhc = "catFallback-" + escape(pageConfig.occasion.categoryFallback)
    $loadMoreBtn = $(loadMoreTemplate.render I18n.mixin(campaign: pageConfig.occasion, pageLimit: pageConfig.pageLimit, newRenderEnabled: pageConfig.newRender, nextOffset: 0, paginationBhc: paginationBhc), hoganPartials)
    $loadMoreBtnA = $loadMoreBtn.find('a#load-more-deals')
    if classes
      $loadMoreBtnA.addClass(classes)
    if title
      textNodeBefore $loadMoreBtnA.find('.deal-title'), title
      $loadMoreBtnA.attr('data-set-label', title)
    for key, value of extraAttr
      $loadMoreBtnA.attr(key, value)
    $loadMoreBtnA.on('click', loadMoreDealsEvent)
    container.append($loadMoreBtn)
    $loadMoreBtnA

  removePriceWrap = ($dealPrice) ->
    $priceWrap = $dealPrice.find('.price-wrap')
    if $priceWrap.length
      $priceWrap.find('.message').remove()
      $priceWrap.contents().unwrap()

  wrapPriceMessaging = ($dealPrice, label, labelClass, attrs) ->
    removePriceWrap $dealPrice
    $urgent = $(document.createElement('span'))
    $urgent.attr attrs
    $dealPrice.append textNode(' ')
    $dealPrice.append $('<span class="message '+labelClass+'">'+label+'</span>')
    $dealPrice.contents().wrapAll $urgent

  cardsForResp = (json) ->
    return json.deals or json.cards

  metaForDeal = (deal) ->
    dealData = dataForDeal(deal)
    paginatedKey = if dealData.optionUuid then dealData.id + '_' + dealData.optionUuid else dealData.id
    return {dealData: dealData, cardHtml: htmlForDeal(deal), paginatedKey: paginatedKey}

  htmlForDeal = (deal) ->
    return deal.cardHtml

  dataForDeal = (deal) ->
    return deal.data or deal

  dealDataIntoResultNode = (dealData, resultNode) ->
    link = $("a", resultNode)
    if dealData.track
      link.parent('figure').attr 'data-bhc', dealData.track
    if dealData.innerTrack
      dealData.innerTrack = dealData.innerTrack.match(/"(.+)"/)[1]
    link.removeAttr 'data-bhc-path'
    link.attr 'data-bhc', dealData.innerTrack or 'deal:' + dealData.uuid
    link.attr 'data-bhd', '{"permalink":"'+dealData.id+'"}'
    link.attr 'data-pagination-id', dealData.id
    link.attr 'class', 'deal-url'
    link.removeAttr 'id'
    link.removeAttr 'data-next-offset'
    link.removeAttr 'data-max-offset'
    link.removeClass 'load-more-deals'
    link.removeClass 'load-more-choices'
    is_urgent = false
    # for testing incentives or urgency, you may randomly show them
    # if Math.random() * 10 < 5
    #   dealData.incentives = [{shortMessage: 'Short Incentive', longMessage: 'Long Incentive Message'}]
    # if Math.random() * 10 < 5
    #   dealData.priceSummary.regularPrice = 1.0
    #   dealData.priceSummary.pricingMetadata = {offerLabelDescriptive: "Super Urgent"}

    if dealData.displayOriginal and dealData.priceSummary.regularPrice
      is_urgent = true
      label = dealData.priceSummary.pricingMetadata.offerLabelDescriptive
      wrapPriceMessaging $(".deal-price", link), label, '',
        class: 'urgent price-wrap'
        title: label
        alt: label
    else if dealData.incentives and dealData.incentives.length > 0
      is_urgent = true
      label = dealData.incentives[0].shortMessage
      longlabel = dealData.incentives[0].longMessage
      wrapPriceMessaging $(".deal-price", link), label, dealData.incentives[0].incentiveClassName or '',
        class: 'incentive price-wrap'
        title: longlabel
        alt: longlabel
    else
      removePriceWrap $(".deal-price", link)
    if dealData.isSoldOut
      if $(resultNode).find('figcaption .sold-out').length < 1
        $soldOut = $(soldOutTemplate.render I18n.mixin {})
        $(resultNode).find('figcaption').append($soldOut)
    link.attr "href", dealData.dealUrl or "/deals/" + dealData.id
    $img = $("img", link);
    if $img.attr('src').match(/jN-75x45\..{3}$/) # transparent sizing png
      $img.css "background-image": "url(#{dealData.largeImageUrl})"
    else
      $img.attr "src", dealData.largeImageUrl
    $("img", link).attr "alt", dealData.title
    $(".deal-title", link).text dealData.announcementTitle
    $(".description", link).text dealData.title
    $(".merchant-name", link).text dealData.variationName or dealData.merchant.name
    $(".deal-location", link).text dealData.redemptionLocation or ''
    minQuantity = dealData.priceSummary?.minimumPurchaseQuantity or 1

    original_price = ''
    if dealData.displayOriginal
      $(".original-price", link).text dealData.priceSummary.value.formattedAmount # min purchase qty applied server side
    else
      $(".original-price", link).remove()

    $(".current-price", link).text dealData.priceSummary.price.formattedAmount # min purchase qty applied server side
    if dealData.displayFromText
      $(".deal-price .from", link).text(I18n.t 'js.modules.merchandising_occasions.priced_from')
    else
      $(".deal-price .from", link).text("")

    #ten combined price length included '.', ',' and currency symbols should only trigger for prices like $10.99 $9.99
    if is_urgent and (dealData.priceSummary.price.formattedAmount.length + dealData.priceSummary.value.formattedAmount.length) >= 10
      link.closest(".block-grid.four-up").addClass("urgent-pack")

  hideThemeRow = (dealRow) ->
    $(dealRow).prev().css({display:'none'})
    $(dealRow).css({display:'none'})
    $(window).trigger("scroll")

  loadThemeDeals = ()->
    dealRow = this
    if dealRow
      resultNodes = $(".deal-card", dealRow)
      query_filter_string = urlUtils.apiQueryBuilder paginationCard.loadButtonAttributes($(dealRow), pageConfig)
      $(dealRow).unbind('enterviewport', loadThemeDeals)
      $.ajax
        url: "/occasion/deals-json?#{query_filter_string}&limit=#{resultNodes.length}"
        dataType: "json"
        timeout: 4000
        success: (json) ->
          cards = cardsForResp json
          if cards
            $(dealRow).removeClass('deal-load')
            r = 0
            rl = cards.length
            nl = resultNodes.length
            if rl < nl
              hideThemeRow(dealRow)
            else
              totalDeals =  if json and json.pagination and json.pagination.count then json.pagination.count else ''
              $(dealRow).parent('.row.pad-row').find('.view-all').text(I18n.pluralize(totalDeals-0, 'js.modules.merchandising_occasions.see_all_deals_link'))
              while r < rl and r < nl
                dealData = dataForDeal cards[r]
                cardHtml = htmlForDeal cards[r]
                if cardHtml
                  newCard = $(cardHtml)
                  $(resultNodes[r]).closest('li').replaceWith(newCard)
                else
                  dealDataIntoResultNode(dealData, resultNodes[r])
                r++
              Groupon.Utils.lazyLoadImages()
              GIG.Utils.truncateElements(dealRow)
              getCardUi().init($('.card-ui').not('.is-initialized'))

        error: ->
          hideThemeRow(dealRow)

  positionInAppMessages = ()->
    $inapp = $('#ls-in-app-messages')
    dest = $('#ls-banner-holder')
    if $inapp.length
      if dest.length
        dest.append($inapp)
      else if $('.giftable-secondary').length
        $inapp.css({display:'block'})
      else
        dest = $('.standard.new .deal-card')[2] || $('.standard .deal-card')[1] || $('.events-page .deal-card')[5]
        $dest = $(dest).parent('li')
        dest = $dest[0]
        if dest
          $newLi = $(document.createElement('li'))
          $newLi.css
            width: '100%'
            height: 'auto'
          $newLi.insertAfter($dest)
          $newLi.append($inapp)
      if dest
        $inapp.css({display:'block'})
      $inapp.on("click", ".hide-link", () -> $inapp.slideUp())

) $ ? null
